"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = BasicValue;
const react_1 = __importDefault(require("react"));
const mui_1 = require("tss-react/mui");
const is_object_1 = __importDefault(require("is-object"));
const material_1 = require("@mui/material");
// locals
const ui_1 = require("../../ui");
const useStyles = (0, mui_1.makeStyles)()(theme => ({
    fieldValue: {
        wordBreak: 'break-word',
        maxHeight: 300,
        fontSize: 12,
        padding: theme.spacing(0.5),
        overflow: 'auto',
    },
}));
function BasicValue({ value }) {
    const { classes } = useStyles();
    const isLink = `${value}`.match(/^https?:\/\//);
    return (react_1.default.createElement("div", { className: classes.fieldValue }, react_1.default.isValidElement(value) ? (value) : isLink ? (react_1.default.createElement(material_1.Link, { href: `${value}` }, `${value}`)) : (react_1.default.createElement(ui_1.SanitizedHTML, { html: (0, is_object_1.default)(value) ? JSON.stringify(value) : String(value) }))));
}
